import React from 'react'
import {Doughnut} from 'react-chartjs-2'
import {Chart as ChartJS, ArcElement, Tooltip, ChartOptions} from 'chart.js'

ChartJS.register(ArcElement, Tooltip)

type Props = {
  studyGuidePercentage: number
  flexiblePercentage: number
}

const VersusChart = ({studyGuidePercentage, flexiblePercentage}: Props) => {
  const data = {
    labels: ['Guided Study Process', 'Flexible Study'],
    datasets: [
      {
        data: [studyGuidePercentage, flexiblePercentage],
        backgroundColor: ['#1377D4', '#ABD264'],
        hoverBackgroundColor: ['#1377D4', '#ABD264'],
        borderWidth: 0,
      },
    ],
  }

  const options: ChartOptions<'doughnut'> = {
    cutout: '60%',
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        position: 'nearest',
        callbacks: {
          label: tooltipItem => {
            const value = tooltipItem.raw as number
            return `${tooltipItem.label}: ${value}%`
          },
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  }

  return <Doughnut data={data} options={options} />
}

export default VersusChart
